"use client";

import { api } from "@/trpc/react";
import { useAppContext } from "@/contexts/AppContext";
import GetStarted from "@/components/dashboard/GetStarted";
import { StatCard } from "@/components/dashboard/StatCard";
import { BookIcon, RocketLaunchIcon } from "@phosphor-icons/react";
import { ResourceCard } from "@/components/dashboard/ResourceCard";
import { SectionTitle } from "@/components/ui/section-title";

import { useSetPageTitle } from "@/contexts/PageNameContext";
import ProgressBar from "@/components/ui/progress-bar";
export default function DashboardPage() {
  useSetPageTitle("Dashboard");

  const { data: usageStatus } = api.billing.getUsageStatus.useQuery();
  const { data: apiUsage, isLoading: isApiUsageLoading } =
    api.billing.getCurrentAPICallsUsage.useQuery();
  const { data: mauUsage, isLoading: isMauUsageLoading } =
    api.billing.getCurrentMAUUsage.useQuery();
  const { currentProject, projects, currentPlan } = useAppContext();

  const getStartedUrl = () => {
    if (currentProject && !usageStatus?.hasUsage) {
      return `/getting-started`;
    } else {
      return "/projects/new";
    }
  };

  if (!currentProject) return null;

  // Format API requests
  const formatAPIRequests = (count: number) => {
    if (count >= 1000000) {
      return `${(count / 1000000).toFixed(1)}M`;
    }
    if (count >= 1000) {
      return `${(count / 1000).toFixed(0)}k`;
    }
    return count.toString();
  };

  return (
    <div className="flex flex-col gap-spacing-10">
      <div className="flex flex-col gap-6">
        <SectionTitle title="Platform Dashboard" />

        {/* Stats Cards */}
        <GetStarted gettingStartedUrl={getStartedUrl} />

        {/* Stats Cards Row */}
        <div className="flex gap-spacing-4">
          {/* Total Projects Card */}
          <StatCard
            title="Total Projects"
            mainValue={projects.length.toString()}
          />

          {/* MAUs Card */}
          <StatCard
            title="MAUs"
            mainValue={mauUsage?.currentUsage.toString() || "0"}
            isLoading={isMauUsageLoading}
            bottomContent={
              <div className="flex items-center gap-1">
                {/* 
                 <ArrowUpRightIcon className='text-palette-mint-800' />
                 <p className="palette-text-details paragraphs-Medium-Medium">
            ↑ {statsData.mauGrowth}% from last month
          </p> */}
              </div>
            }
          />

          {/* API Requests Card */}
          <StatCard
            title={currentPlan?.displayName + " Plan"}
            mainValue={
              apiUsage?.currentUsage
                ? ((apiUsage.currentUsage / 1000) * 100).toFixed(2) + "%"
                : "0%"
            }
            isLoading={isApiUsageLoading}
            bottomContent={
              <div className="w-full">
                <div className="flex justify-between mb-1">
                  <span className="font-medium text-sm text-palette-text-progress-bar">
                    {`${formatAPIRequests(apiUsage?.currentUsage || 0)} / 1,000 Requests`}
                  </span>
                </div>
                <ProgressBar value={apiUsage?.currentUsage || 0} />
              </div>
            }
          />
        </div>
      </div>

      {/* Resources */}
      <div className="flex flex-col gap-spacing-6 h-[344px] pb-spacing-9">
        <SectionTitle
          title="Resources"
          subtitle="Everything you need to get started, or dive deeper"
        />
        <div className="flex gap-spacing-4 h-[208px]">
          <ResourceCard
            icon={<BookIcon size={24} />}
            title="Documentation"
            subtitle="Learn how to use Copilot Cloud features"
            url="https://docs.copilotkit.ai"
            buttonText="View Documentation"
          />
          <ResourceCard
            icon={<RocketLaunchIcon size={24} />}
            title="Getting Started"
            subtitle="Follow our guide to quickly set up and deploy you application."
            url="https://docs.copilotkit.ai/getting-started"
            buttonText="Set up you first AI-Powered application"
          />
        </div>
      </div>
    </div>
  );
}
